<template>
  <ContactPersonForm />
</template>
  
<script>
  import ContactPersonForm from '@/components/tournament-contact-person/ContactPersonForm.vue';
  export default {
    name: "ContactPersonCreatePage",
    components: {
      ContactPersonForm,
    },
  };
</script>
  